import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { Prospections, CreateProspection, UpdateProspection } from "./pages";

export const ProspectionsRouter = [
  <Route
    path="/prospections"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Prospections />
      </ProtectedRoute>
    }
  />,

  <Route path="/prospection">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateProspection />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateProspection />
        </ProtectedRoute>
      }
    />
  </Route>,
];
